import { ComponentProps } from 'react'
import classNames from 'classnames'

export const Slider = (props: ComponentProps<'input'>) => {
    return (
        <input
            type="range"
            {...props}
            className={classNames(
                'h-8 w-full cursor-default appearance-none !border-transparent !bg-transparent !p-0 shadow-none !outline-0',
                // -- webkit
                '[&::-webkit-slider-runnable-track]:w-full [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-neutral-600 dark:[&::-webkit-slider-runnable-track]:bg-neutral-600',
                '[&::-webkit-slider-thumb]:focus:bg-accent-500 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-neutral-200',
                '[&::-webkit-slider-runnable-track]:h-2 [&::-webkit-slider-thumb]:-mt-1 [&::-webkit-slider-thumb]:size-4',
                // mozilla
                '[&::-moz-range-track]:focus:bg-accent-300 [&::-moz-range-track]:w-full [&::-moz-range-track]:rounded-full [&::-moz-range-track]:bg-neutral-600 dark:[&::-moz-range-track]:bg-neutral-600',
                '[&::-moz-range-thumb]:focus:bg-accent-500 [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-neutral-200',
                '[&::-moz-range-thumb]:-mt-1 [&::-moz-range-thumb]:size-4 [&::-moz-range-track]:h-2'
            )}
        />
    )
}
